// Müqavilə ekranlarının saf məntiqi (KT-82): status nişanı, məbləğ mətni, baxışda sahənin rəngi. Testlər contracts.spec.ts.
import type { ContractAnnexRow, ContractPreviewPart, ContractRow } from '@kassa/shared';
import { isoToDmy } from './dates';

export interface Badge {
  cls: 'badge-ok' | 'badge-bad' | 'badge-warn' | 'badge-off';
  label: string;
}

/** Müqavilənin vəziyyəti: rəng tək deyil, yanında söz (rəng korluğu). */
export function contractBadge(k: Pick<ContractRow, 'status' | 'expired' | 'validUntil'>): Badge {
  if (k.status === 'terminated') return { cls: 'badge-bad', label: 'Ləğv edilib' };
  if (k.status === 'draft') return { cls: 'badge-off', label: 'Qaralama' };
  if (k.expired || k.status === 'expired') return { cls: 'badge-bad', label: `Müddəti bitib${k.validUntil ? ` · ${isoToDmy(k.validUntil)}` : ''}` };
  return { cls: 'badge-ok', label: k.validUntil ? `Qüvvədədir · ${isoToDmy(k.validUntil)}-dək` : 'Qüvvədədir' };
}

export function annexBadge(status: ContractAnnexRow['status']): Badge {
  switch (status) {
    case 'signed':
      return { cls: 'badge-ok', label: 'İmzalanıb' };
    case 'sent':
      return { cls: 'badge-warn', label: 'Göndərilib' };
    case 'cancelled':
      return { cls: 'badge-bad', label: 'Ləğv edilib' };
    default:
      return { cls: 'badge-off', label: 'Hazırlanıb' };
  }
}

/** Onluq sətir → «1 234,56» (float yoxdur). */
export function amountText(amount: string): string {
  const [i, f = ''] = amount.split('.');
  const neg = i.startsWith('-');
  const digits = neg ? i.slice(1) : i;
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${neg ? '−' : ''}${grouped},${(f + '00').slice(0, 2)}`;
}

export type PreviewMode = 'template' | 'filled';

/** Baxışda sahə: şablonda sarı, doldurulmuşda dəyər yaşıl, boş qırmızı. */
export function fieldClass(part: Extract<ContractPreviewPart, { kind: 'field' }>, mode: PreviewMode): string {
  if (mode === 'template') return 'cf cf-tpl';
  return part.value === null ? 'cf cf-missing' : 'cf cf-filled';
}

export function fieldText(part: Extract<ContractPreviewPart, { kind: 'field' }>, mode: PreviewMode): string {
  return mode === 'filled' && part.value !== null ? part.value : `#${part.tag}#`;
}

/** Sahə adı (Mətni sahə et): kiçik hərf, boşluqsuz, yalnız hərf/rəqəm/_ (server də yoxlayır). */
export function normalizeFieldName(name: string): string | null {
  const t = name.trim().replace(/^#|#$/g, '').toLocaleLowerCase('az');
  return /^[\p{L}\p{N}_]{1,40}$/u.test(t) ? t : null;
}
